import React from 'react';
import Icon from './Close.svg';

export default (props) => <Icon {...props} />;
